import * as React from 'react';
import { Progress as ProgressPrimitive } from 'radix-ui';

import { cn } from '@/shared/lib/utils';

// shadcn/ui Progress primitive (new-york, radix-ui umbrella import). Repo-local baseline –
// Phoenix kompozice viz `@/shared/ui/mini-progress-bar`. `indicatorClassName` umožní obarvit výplň (tone).
// Indikátor je vykreslený přes `asChild` na DOM <div>, aby dynamický transform nešel přes `style` na komponentě.
function ShadcnProgress({
  className,
  indicatorClassName,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & { indicatorClassName?: string }) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn('bg-primary/20 relative h-2 w-full overflow-hidden rounded-full', className)}
      {...props}
    >
      <ProgressPrimitive.Indicator asChild>
        <div
          data-slot="progress-indicator"
          className={cn('bg-primary h-full w-full flex-1 transition-all', indicatorClassName)}
          style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        />
      </ProgressPrimitive.Indicator>
    </ProgressPrimitive.Root>
  );
}

export { ShadcnProgress };
